__webpack_require__.p = "https://icy-rock-0cf259f03.4.azurestaticapps.net/";